module.exports = __webpack_public_path__ + "static/media/media1.4d97a33d.jpeg";